<template>
  <div class="jewelry-card">
    <a :href="result.detailPage">
      <DefImg :result="result.picture" />
    </a>

    <div class="jewelry-card-main">
      <DefTags v-if="result.tags" :result="result.tags" />
      <span class="jewelry-card-main__date">{{ result.date }}</span>
    </div>

    <div class="jewelry-card-footer">
      <a :href="result.detailPage" class="jewelry-card-footer__name" v-html="result.name" />
      <p v-if="result.previewText" class="jewelry-card-footer__text" v-html="result.previewText" />
    </div>
  </div>
</template>

<script>
import DefImg from '@components/Def/DefImg/DefImg.vue';
import DefTags from '@components/Def/DefTags/DefTags.vue';

export default {
  name: 'JewelryCard',
  components: { DefTags, DefImg },
  props: {
    result: {
      type: Object,
    },
  },
};
</script>

<style lang="scss">
.jewelry-card {
  background-color: #fff;
  height: 100%;
  :deep(.def-img) {
    margin-left: auto;
    margin-right: auto;
  }
}
.jewelry-card-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  &__date {
    color: #757575;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
  }
}
.jewelry-card-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px 16px;
  &__name {
    font-size: 16px;
    font-weight: 500;
    line-height: 120%;
    letter-spacing: 1.28px;
    text-transform: uppercase;
    margin-bottom: 8px;
  }
  &__text {
    font-size: 14px;
    font-weight: 400;
    line-height: 120%;
    color: #757575;
  }
}
</style>
